<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum">
</app-header>

<div class="container-header">
    <div class="container-header-inner">

        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Configurações de campos obrigatórios</h1>
                        <p class="welcome-message">
                            <button mat-icon-button type="button" (click)="voltar()">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Gerencie a lista de campos que devem ser preenchidos obrigatoriamente. Campos listados
                            abaixo serão exigidos.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        @if (isLoading) {
        <div class="row">
            <div class="col-12">
                <app-loading-box height="24" width="40%" marginTop="24"></app-loading-box>
                <app-loading-box height="16" width="60%" marginTop="8"></app-loading-box>
                <div class="row g-3 mt-0">
                    <div class="col-12 col-md-4">
                        <app-loading-box height="72" width="100%"></app-loading-box>
                    </div>
                    <div class="col-12 col-md-4">
                        <app-loading-box height="72" width="100%"></app-loading-box>
                    </div>
                    <div class="col-12 col-md-4">
                        <app-loading-box height="72" width="100%"></app-loading-box>
                    </div>
                </div>
            </div>
        </div>
        } @else {
        @for (tela of listaTelaComCampos; track tela) {
        <app-campos-obrigatorios-secao [tela]="tela" [seletorAberto]="telaComSeletorAberto === tela"
            (seletorAbertoChange)="onSeletorAbertoChange(tela, $event)"></app-campos-obrigatorios-secao>
        }
        }

    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>
